import CONSTANTS from '../CONSTANTS';

const initialState = {
  kafka: [],
};

const kafkaReducer = (state = initialState, action) => { 
  switch (action.type) {
    case CONSTANTS.KAFKA_SET_LIST:
        return { ...state, kafka: action.kafka};   
    default:
      return state;
  }
};

export default kafkaReducer;